import { AskLumappsRule } from '@lumapps/ask-lumapps-rules/types';
import { Route } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';

import { ASK_LUMAPPS_ADMIN_ROOT_PATH } from './constants';
import { AskLumappsAdminPaths } from './types';

const getAskLumappsAdminPath = (path: AskLumappsAdminPaths) => `${ASK_LUMAPPS_ADMIN_ROOT_PATH}/${path}`;

export const askLumappsSourcesAdminRoute: Route = {
    path: getAskLumappsAdminPath('sources'),
    legacyId: 'app.admin.ai-search-sources',
    appId: AppId.backOffice,
};
export const askLumappsSourcesAdmin = (): Route => askLumappsSourcesAdminRoute;

/**
 * Ask Lumapps Rules Routes
 */
/** List */
export const askLumappsBaseRulesAdminRoute: Route = {
    path: getAskLumappsAdminPath('rules'),
    legacyId: 'app.admin.ai-search-rules',
    appId: AppId.backOffice,
};
export const askLumappsBaseRulesAdmin = (): Route => askLumappsBaseRulesAdminRoute;

/** Edit */
export const askLumappsEditRuleRoute: Route = {
    ...askLumappsBaseRulesAdminRoute,
    path: `${getAskLumappsAdminPath('rules')}/edit/:id`,
};
export const askLumappsEditRule = (rule: Pick<AskLumappsRule, 'id'>): Route => ({
    ...askLumappsEditRuleRoute,
    params: {
        id: rule.id,
    },
});

export interface RuleParams {
    id: string;
}

/** Create */
export const askLumappsCreateRuleRoute: Route = {
    ...askLumappsBaseRulesAdminRoute,
    path: `${getAskLumappsAdminPath('rules')}/create`,
};
export const askLumappsCreateRule = (): Route => ({
    ...askLumappsEditRuleRoute,
});

/**
 * Ask Lumapps Concepts Route
 */
export const askLumappsConceptsAdminRoute: Route = {
    path: getAskLumappsAdminPath('expressions'),
    legacyId: 'app.admin.ai-search-concepts',
    appId: AppId.backOffice,
};

export const askLumappsConceptsAdmin = (): Route => askLumappsConceptsAdminRoute;
